import React from "react";
import "./rightpanel.css";
import { config } from "../config";
import Category from "./category";
import Askabout from "./Askabout";
import History from "../pages/History";
import Footer from "./footer";
import { useNavigate } from "react-router-dom";
const RightPanel = () => {
  const navigate = useNavigate();

  const handleNavigate = (key) => {
    navigate("/create-academic", { state: { key } });
  };

  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);
  return (
    <div className="background_righPanel">
      <div className="title_rightPanel">Ai Legal Document Generator</div>

      <div className="buttons_container">
        <div className="buttons_rightPanel">
          <button
            className="button_rightPanel"
            onClick={() => navigate("/create-legal-document")}
          >
            <img
              className="buttonimg_rightPanel"
              src={config.createLegal}
              alt=""
            />
            Create Legal Documents
          </button>
          <button
            className="button_rightPanel"
            onClick={() => navigate("/case-analyzer")}
          >
            <img
              className="buttonimg_rightPanel"
              src={config.caseSummarizer}
              alt=""
            />
            Case Summarizer
          </button>
          <button
            className="button_rightPanel"
            onClick={() => navigate("/ai-assistant")}
          >
            <img
              className="buttonimg_rightPanel"
              src={config.aiAssistant}
              alt=""
            />
            AI Legal Assistant
          </button>
          <button
            className="button_rightPanel"
            onClick={() => navigate("/premium")}
          >
            <img
              className="buttonimg_rightPanel"
              src={config.buyPremium}
              alt=""
            />
            Buy premiuim
          </button>
        </div>
      </div>

      <div>
        <Category />

        <Askabout />
      </div>
      <Footer />
    </div>
  );
};

export default RightPanel;
